import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoEe: CultureInfo = {
  name: 'ee',
  displayName: 'Eʋegbe',
  iso3LanguageCode: 'ewe',
  iso2LanguageCode: 'ee',
  ietfLanguageTag: 'ee',
  parent: null
};
